<template>
    <div class="topicIndex spackage padding-20 bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="已加入用户" name="joinUser">
                <!-- start 顶部菜单栏 -->
                <section class="startMgt-header">
                    <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <!--<el-select v-model="gradeValue" placeholder="全部等级">-->
                    <!--<el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
                    <!--</el-select>-->
                    <!--<el-select v-model="integralValue" placeholder="积分区间">-->
                    <!--<el-option v-for="item in integral" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
                    <!--</el-select>-->
                    <el-input placeholder="输入用户名称" v-model="searchName" style="width: 240px"></el-input>
                    <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                </section>
                <!-- end 顶部菜单栏 -->
                <section>
                    <el-table :data="userData">
                        <el-table-column prop="name" label="用户名称" align="center">
                            <template slot-scope="scope">
                                <div class="customerBox">
                                    <img :src="scope.row.headlogourl">
                                    <span class="recommon">{{scope.row.name}}</span>
                                    <span class="manger" v-if="scope.row.roletype=='2'">管理员</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="roletypename" label="角色" align="center"></el-table-column>
                        <!--<el-table-column prop="datetime" label="积分" align="center"></el-table-column>-->
                        <el-table-column prop="subjectcount" label="帖子数" align="center"></el-table-column>
                        <el-table-column prop="filecount" label="资料数" align="center"></el-table-column>
                        <el-table-column prop="datetime" label="加入时间" align="center"></el-table-column>
                        <el-table-column label="操作" align="right">
                            <template slot-scope="scope">
                                <el-dropdown v-if="scope.row.roletype!='1' && scope.row.issockpuppet!='1'">
                              <span class="el-dropdown-link">
                                更多
                              </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item><span @click="modifyClick(scope.row.innerid,scope.row.roletype)">{{scope.row.roletype=='99'?'设为管理员':'取消管理员'}}</span></el-dropdown-item>
                                        <!--<el-dropdown-item><span>禁言</span></el-dropdown-item>-->
                                        <!--<el-dropdown-item><span>加入黑名单</span></el-dropdown-item>-->
                                        <!--<el-dropdown-item><span>积分管理</span></el-dropdown-item>-->
                                        <!--<el-dropdown-item><span>经验值管理</span></el-dropdown-item>-->
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                    <page :total="total" ref="page" @getList="searchClick"></page>
                </section>
            </el-tab-pane>
            <el-tab-pane label="待审核用户" name="noJoinUser">
                <!-- start 顶部菜单栏 -->
                <section class="startMgt-header">
                    <el-date-picker class="item" v-model="time2.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="statusValue" placeholder="用户状态">
                        <el-option v-for="item in userStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-input placeholder="输入用户名称" v-model="searchName2" style="width: 240px"></el-input>
                    <el-button type="primary" @click="handleQuery2" plain>搜索</el-button>
                </section>
                <!-- end 顶部菜单栏 -->
                <section>
                    <el-table :data="userJoinData">
                        <el-table-column prop="applycustomername" label="用户名称" align="center">
                            <template slot-scope="scope">
                                <div class="customerBox">
                                    <img :src="scope.row.applylogourl">
                                    <span class="recommon">{{scope.row.applycustomername}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="memo" label="验证信息" align="center"></el-table-column>
                        <el-table-column prop="datetime" label="申请时间" align="center"></el-table-column>
                        <el-table-column label="操作" align="right">
                            <template slot-scope="scope">
                                <div class="table-position" v-if="scope.row.status=='0'">
                                    <span @click="agreeClick(scope.row.applycode)">通过</span>
                                    <span>｜</span>
                                    <span @click="refuseClick(scope.row.applycode)">拒绝</span>
                                </div>
                                <div class="table-position" v-if="scope.row.status=='11'">
                                    <span>已拒绝</span>
                                </div>
                                <div class="table-position" v-if="scope.row.status=='10'">
                                    <span>已同意</span>
                                </div>
                            </template>
                            <!--<template slot-scope="scope">-->
                                <!--<div class="table-position">-->
                                    <!--<span>已拒绝</span>-->
                                <!--</div>-->
                            <!--</template>-->
                            <!--<template slot-scope="scope">-->
                                <!--<div class="table-position">-->
                                    <!--<span>已同意</span>-->
                                <!--</div>-->
                            <!--</template>-->
                        </el-table-column>
                    </el-table>
                    <page :total="total" ref="page2" @getList="searchClick2"></page>
                </section>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {getUserList, modifyUserRole, delNotice,getJoinApplyList,dealJoinApply} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "userMgt",
        data() {
            return {
                value1: '', //日期
                statusValue: '',
                userStatus: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '待审核'
                    },
                    {
                        value: '10',
                        label: '已同意'
                    }, {
                        value: '11',
                        label: '已拒绝'
                    }],
                total: 0,
                userData: [], //已加入用户数据
                userJoinData: [], //待审核用户数据
                total2: 0,
                searchName: '', //搜索用户
                searchName2: '', //搜索用户2
                time: {             // 开始/结束时间
                    date: ''
                },
                time2: {             // 开始/结束时间
                    date: ''
                },
                activeName: 'joinUser', //选项卡默认显示
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starid: this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.userMgtEvent();
            this.joinApplyEvent()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            handleQuery2(){
                this.$refs.page2.handleSizeChange(1)
            },
            ...mapActions([
                'setLoading'
            ]),
            handleTabClick(tab) {
                if (tab.name === 'joinUser') {
                    this.userMgtEvent();
                } else if (tab.name === 'noJoinUser') {
                    this.joinApplyEvent()
                }
            },
            //用户列表
            userMgtEvent() {
                getUserList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.userData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 修改成员角色
            modifyClick(id, type) {
                let params = {
                    starid: this.$route.query.innerid,
                    roletype: type == '2' ? '99' : '2',
                    meberid: id,
                };
                this.setLoading(true);
                modifyUserRole({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.userMgtEvent();
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    starid: this.$route.query.innerid,
                    keyword: this.searchName,
                    beginTime: searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endTime: searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                console.log(params);
                getUserList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.userData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
            // 待审核搜索
            searchClick2() {
                this.setLoading(true);
                let searchDate = this.time2;
                let params = {
                    starid: this.$route.query.innerid,
                    keyword: this.searchName2,
                    status:this.statusValue,
                    beginTime: searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endTime: searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getJoinApplyList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.userJoinData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
            // 待审核用户列表
            joinApplyEvent(){
                getJoinApplyList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.userJoinData = data.data.content;
                        this.total2 = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 同意加入
            agreeClick(id){
                this.$confirm('同意该用户加入本星球？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        applycode: id,
                        dealresult:10
                    };
                    this.setLoading(true);
                    dealJoinApply({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.joinApplyEvent();
                            this.$message.success(`已同意!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消同意'
                    })
                })
            },
            // 拒绝加入
            refuseClick(id){
                this.$prompt('输入拒绝的理由', '拒绝', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: '',
                }).then(({value}) => {
                    let params = {
                        applycode: id,
                        dealresult:11,
                        dealmemo:value
                    };
                    console.log(params);
                    this.setLoading(true);
                    dealJoinApply({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.joinApplyEvent();
                            this.$message.success(`已拒绝!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    })
                })
            },

        },
        computed: {
            ...mapGetters([
                'page',
                'page2'
            ])
        },
    }
</script>

<style scoped lang="scss">
    .topicIndex {
        display: flex;
        flex-direction: column;
    }

    .startMgt-header {
        width: 100%;
        height: 40px;
        margin-bottom: 12px;
        display: flex;
        .el-input__icon {
            height: 36px;
            line-height: 0 !important;
        }
        .el-select, .el-select > .el-input, .el-button {
            height: 32px;
        }
        .el-select {
            width: 116px;
        }
        .el-select, .el-input {
            margin-right: 20px;
        }
    }

    .customerBox {
        display: flex;
        align-items: center;
        img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
        .manger {
            width: 50px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            background: rgba(230, 162, 60, 1);
            border-radius: 2px;
            position: absolute;
            bottom: 10px;
        }
    }

    .table-position {
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
            color: #409EFF;
            cursor: pointer;
        }
    }

    .el-dropdown-link {
        color: #409EFF;
    }

    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner {
        padding: 0 10px;
    }

    .topicIndex .el-date-editor {
        margin-right: 20px;
    }

    /*选项卡样式更改*/
    .el-tabs__nav-wrap::after {
        height: 1px !important;
    }
    /*弹窗文字样式*/
    .el-message-box .el-message-box__content{
        color: #606266!important;
    }
</style>
